import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { handleOpenSidePanel } from '../../../store/slices/sidePanelSlice';
import { SidePanelProps } from './SidePanel.types';
import { DocumentEditor } from '../../features/Documentation/DocumentEditor';
import { useParams } from 'react-router-dom';
import { fetchRequirementStepsByAISystemId } from '../../../store/slices/requirementStepsSlice';

export function SidePanel({
  title,
  content,
  annexId,
  declarationId,
  friaId,
  dpiaId,
}: SidePanelProps) {
  const { openSidePanel } = useAppSelector((state) => state.sidePanel);
  const { id: aiSystemId } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();

  const handleClose = () => {
    if ((content === 'ANNEX_IV' || annexId) && aiSystemId) {
      dispatch(fetchRequirementStepsByAISystemId(aiSystemId));
    }

    dispatch(handleOpenSidePanel(false));
  };

  return (
    <div>
      <Dialog open={openSidePanel} onClose={() => {}} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500/75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
        />
        <div className="fixed inset-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
              <DialogPanel
                transition
                className="pointer-events-auto w-[984px] transform transition duration-500 ease-in-out data-[closed]:translate-x-full sm:duration-700"
              >
                <div className="relative h-full p-6 shadow-xl bg-white">
                  <DocumentEditor
                    title={title}
                    content={content}
                    annexId={annexId}
                    declarationId={declarationId}
                    friaId={friaId}
                    dpiaId={dpiaId}
                    onClose={handleClose}
                    showHeader={true}
                    showFooter={true}
                    showZoomControls={true}
                    showDownloadButton={true}
                    showCloseButton={true}
                  />
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}
